import { IBillingDetail } from '@nkr/models/index';
import { BillableNephrectomyStatus } from '@nkr/enums/index';
import { DropdownButton, MenuItem } from 'react-bootstrap';

interface IProps {
    data: IBillingDetail,
    onStartBilling: (donorId: number) => void,
    onBilledManually: (donorId: number) => void
}

const PendingRow = (props: IProps) => {
    const handleStartBilling = () => {
        props.onStartBilling(props.data.billableNephrectomy.donor.id);
    };

    const handleBilledManually = () => {
        props.onBilledManually(props.data.billableNephrectomy.donor.id);
    };

    const disabledButtons = props.data.billableNephrectomy.id == 0 || props.data.billableNephrectomy.statusId == BillableNephrectomyStatus.PendingDataEntry;
    const item = props.data;

    return (
        <tr>
            <td>{item.billableNephrectomy.transplantDate}</td>
            <td>{item.billableNephrectomy.chainId}/{item.billableNephrectomy.clusterNumber}/{item.billableNephrectomy.positionNumber}</td>
            <td>{item.billableNephrectomy.donor.center.alias} {item.billableNephrectomy.donor.rdnCenterId > 0 ? <span style={{ color: 'darkred' }}>({item.billableNephrectomy.donor.rdnCenterAlias})</span> : null}</td>
            <td>{item.billableNephrectomy.donor.alias}</td>
            <td>{item.billableNephrectomy.recipient.center.alias}</td>
            <td>{item.billableNephrectomy.recipient.alias}</td>
            <td>{item.claimType}</td>
            <td>
                <DropdownButton bsStyle='primary' bsSize='xs' pullRight title='Action' id={`action${props.data.donorId}`}>
                    <MenuItem eventKey='START' disabled={!disabledButtons} onClick={handleStartBilling}>Start Billing</MenuItem>
                    <MenuItem eventKey='MANUALLY' disabled={!disabledButtons} onClick={handleBilledManually}>Mark as Billed Manually</MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey='VIEW' disabled={disabledButtons} onClick={handleStartBilling}>View Invoice</MenuItem>
                </DropdownButton>
            </td>
        </tr>
    );
}

export default PendingRow;